import { Paperclip, Send } from "lucide-react";
import { useT } from "../../../i18n/I18nProvider";
import { Btn, IconBtn } from "../../ui";
import { TemplateMenu, type TemplateSeed } from "./TemplateMenu";

/**
 * The strip under the reply box.
 *
 * Send opens the same composer the box itself opens. That is the point of it:
 * the box reads as a placeholder, and a placeholder with no send button next to
 * it leaves an operator wondering where the message actually goes. Two doors
 * into one composer is cheaper than one door nobody trusts.
 *
 * The address on the right is the account the reply leaves from, and it is the
 * one fact here that can surprise: a CRM with three sending identities can
 * answer from a different mailbox than the one the thread arrived in.
 */
export function ReplyFoot({
  onReply,
  onTemplate,
  fromAddress,
}: {
  onReply: () => void;
  onTemplate: (seed: TemplateSeed) => void;
  fromAddress: string;
}) {
  const t = useT();

  return (
    <div className="crm-reply-act">
      <Btn tone="dark" small onClick={onReply}>
        <Send className="size-4" />
        {t("compose.send")}
      </Btn>

      {/* A third door into the same composer, rather than a picker of its own.
          This strip has no draft behind it - the reply box is a placeholder -
          so a file picked here would have nowhere to go until the composer
          opened anyway. It was disabled while nothing could carry a file; now
          it opens the window where the tray lives. */}
      <IconBtn onClick={onReply} title={t("compose.attachInComposer")} aria-label={t("compose.attachInComposer")}>
        <Paperclip className="size-4" />
      </IconBtn>

      <TemplateMenu onPick={onTemplate} />

      {fromAddress ? (
        <span className="crm-trunc ml-auto pl-2 text-[11px] text-muted-foreground">
          {t("mail.sendingAs", { address: fromAddress })}
        </span>
      ) : null}
    </div>
  );
}
